/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ExportPrompt} from '@ion/dls/src/export/ExportPrompt';
import {
  exportComplete,
  exportConfirmed
} from '@/store/actions/exporter';

/**
 * This is a export status component that will display a snackbar
 * if the export action in progress or complete
 */
export const ExportStatusPrompt = () => {
  const {
    entity,
    isExporting,
    isComplete,
    isError,
    show
  } = useSelector(({exporter}) => exporter.current);
  const dispatch = useDispatch();
  if (show) {
    return (
      <ExportPrompt entity={entity}
        isExporting={isExporting && !isComplete}
        isFailure={isError}
        onComplete={function() {
          dispatch(isComplete ? exportComplete() : exportConfirmed());
        }} />
    );
  }
  return null;
};

export default ExportStatusPrompt;
